<template>
  <div class="page-wrapper-secondary">
    <div class="contact-container flex-container f-between f-wrap">
      <div class="flex-half">
        <div class="page-content p-relative h-100">
          <h1 class="page-title">
            Контакты
          </h1>
          <router-link :to="{ name: 'Contact' }" class="item-anchor d-block text-white p-relative">
            Контактная информация
          </router-link>
          <router-link :to="{ name: 'FeedbackForm' }" class="item-anchor d-block text-white p-relative">
            Форма обратной связи
          </router-link>

          <div class="feedback-form">
            <Form />
          </div>
        </div>
      </div>
      <div class="flex-half">
        <div class="contact-map vh-100" style="padding: 12px;">
          <yandex-map class="yandex-map" :coords="coords" :zoom="10" @click="onClick">
            <ymap-marker :coords="coords" marker-id="123" hint-content="Premier House" />
          </yandex-map>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { yandexMap, ymapMarker } from 'vue-yandex-maps'
import BreadCrumb from "../../components/BreadCrumb";
import Form from "../../components/Form";
export default {
  data() {
    return {
      styles: [
        {
          elementType: "geometry",
          stylers: [
            {
              color: "#212121",
            },
          ],
        },
        {
          elementType: "labels.icon",
          stylers: [
            {
              color: "#ca9760",
            },
            {
              saturation: 10,
            },
            {
              visibility: "off",
            },
            {
              weight: 0.5,
            },
          ],
        },
        {
          elementType: "labels.text.fill",
          stylers: [
            {
              color: "#757575",
            },
          ],
        },
        {
          elementType: "labels.text.stroke",
          stylers: [
            {
              color: "#212121",
            },
          ],
        },
        {
          featureType: "administrative",
          elementType: "geometry",
          stylers: [
            {
              color: "#757575",
            },
          ],
        },
        {
          featureType: "administrative.country",
          elementType: "labels.text.fill",
          stylers: [
            {
              color: "#9e9e9e",
            },
          ],
        },
        {
          featureType: "administrative.land_parcel",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "administrative.locality",
          elementType: "labels.text.fill",
          stylers: [
            {
              color: "#bdbdbd",
            },
          ],
        },
        {
          featureType: "poi",
          elementType: "labels.text.fill",
          stylers: [
            {
              color: "#757575",
            },
          ],
        },
        {
          featureType: "poi.park",
          elementType: "geometry",
          stylers: [
            {
              color: "#181818",
            },
          ],
        },
        {
          featureType: "poi.park",
          elementType: "labels.text.fill",
          stylers: [
            {
              color: "#616161",
            },
          ],
        },
        {
          featureType: "poi.park",
          elementType: "labels.text.stroke",
          stylers: [
            {
              color: "#1b1b1b",
            },
          ],
        },
        {
          featureType: "road",
          elementType: "geometry.fill",
          stylers: [
            {
              color: "#2c2c2c",
            },
          ],
        },
        {
          featureType: "road",
          elementType: "labels.text.fill",
          stylers: [
            {
              color: "#8a8a8a",
            },
          ],
        },
        {
          featureType: "road.arterial",
          elementType: "geometry",
          stylers: [
            {
              color: "#373737",
            },
          ],
        },
        {
          featureType: "road.highway",
          elementType: "geometry",
          stylers: [
            {
              color: "#3c3c3c",
            },
          ],
        },
        {
          featureType: "road.highway.controlled_access",
          elementType: "geometry",
          stylers: [
            {
              color: "#4e4e4e",
            },
          ],
        },
        {
          featureType: "road.local",
          elementType: "labels.text.fill",
          stylers: [
            {
              color: "#616161",
            },
          ],
        },
        {
          featureType: "transit",
          elementType: "labels.text.fill",
          stylers: [
            {
              color: "#757575",
            },
          ],
        },
        {
          featureType: "water",
          elementType: "geometry",
          stylers: [
            {
              color: "#000000",
            },
          ],
        },
        {
          featureType: "water",
          elementType: "labels.text.fill",
          stylers: [
            {
              color: "#3d3d3d",
            },
          ],
        },
      ],
      coords: [
        41.375828, 69.269765
      ],
    };
  },
  components: {
    BreadCrumb,
    Form, yandexMap, ymapMarker
  },
  methods: {
    onClick(e) {
      this.coords = e.get('coords');
    },
  }
};
</script>

<style lang="scss">
.yandex-map {
  height: 99%;
  width: 99.9%;
}
</style>
